import React from 'react';

const NumberContext = React.createContext();
export default NumberContext;